// extracted by mini-css-extract-plugin
export default {"multiSorterContainer":"RecordsOfDeletionsTable_multiSorterContainer__ursy0","multiSorterContainer__sorter":"RecordsOfDeletionsTable_multiSorterContainer__sorter__7TNJb"};